import { useSelector } from 'react-redux';

// `Event.enabled` is the backend's write gate: a closed event stays fully
// readable but refuses every write with 409 `event_read_only`. This hook is the
// UI's mirror of that rule.
//
// Defaults to writable when the flag is missing: an event object persisted by
// an older build has no `enabled` key, and treating that as "closed" would lock
// people out of a perfectly open event until they re-picked it. The backend is
// the actual enforcement, so guessing wrong here is a cosmetic problem only.
export const useEventWritable = () => {
  const currentEvent = useSelector((state) => state.auth.currentEvent);
  return currentEvent?.enabled !== false;
};

export default useEventWritable;
